<template lang="pug">
.container-fluid.text-left
	.card
		.card-header
			span.fa.fa-search.mr-2
			| Búsqueda de contratos
		.card-body
			.row
				.col-xs-12.col-sm-6.col-md-4.col-lg-3
					.form-group(v-if='permisos.contratos_verTodos')
						label(for='agente') Agente
						input.form-control.form-control-sm(@keypress.enter='buscar()' type='text' name='agente' v-model='filtro.agente' placeholder='Escribe el nombre del agente')
					.form-group
						label(for='agente') Cliente
						input.form-control.form-control-sm(@keypress.enter='buscar()' type='text' name='agente' v-model='filtro.cliente' placeholder='Escribe el nombre del cliente')
					.form-group
						label(for='facturado_a') Facturado a
						select.form-control.form-control-sm(@change='buscar()' v-model='filtro.destino' id="facturado_a")
							option(:value='null') Todos
							option(v-for='destino in listadoDestinos' :value='destino.ID_destino') {{ destino.nombre }}
				.col-xs-12.col-sm-6.col-md-4.col-lg-3(style='position: relative;')
					.form-group(style='position: relative;')
						label(for='agente') Desde
						datepicker(:clear-button='true' placeholder="DD-MM-YYYY" :monday-first='true' input-class='form-control form-control-sm' :language='$dateLang' v-model='filtro.fechaIni' @selected='buscar()')
					.form-group(style='position: relative;')
						label(for='agente') Hasta
						datepicker(:clear-button='true' placeholder="DD-MM-YYYY" :monday-first='true' input-class='form-control form-control-sm' :language='$dateLang' v-model='filtro.fechaFin' @selected='buscar()')
					.form-group
						label(for='') Intermediario
						input.form-control.form-control-sm(type='text' placeholder="Escriba el nombre del intermediario" v-model='filtro.intermediario' @keypress.enter='buscar()')
				.col-xs-12.col-sm-6.col-md-4.col-lg-3
					.form-group
						label(for='agente') Evento
						input.form-control.form-control-sm(@keypress.enter='buscar()' type='text' name='agente' v-model='filtro.evento' placeholder='Escribe el evento')
					.form-group
						label(for='agente') Partida
						input.form-control.form-control-sm(@keypress.enter='buscar()' type='text' name='agente' v-model='filtro.partida' placeholder='Escribe la partida')
					.form-group
						label(for='agente') Título
						input.form-control.form-control-sm(@keypress.enter='buscar()' type='text' name='titulo' v-model='filtro.titulo' placeholder='Escribe el título')
				.col-xs-12.col-sm-6.col-md-4.col-lg-3
					.form-group
						label(for='agente') Destino
						input.form-control.form-control-sm(@keypress.enter='buscar()' type='text' name='destino' v-model='filtro.destino' placeholder='Escribe el destino')
					.form-group
						label(for='agente') Estado
						br
						.btn-group
							button(type='button' :class='claseBtnEstado(null)' @click='setEstado(null)') Todos
							button(type='button' :class="claseBtnEstado('Borrador')" @click="setEstado('Borrador')") Borrador
							button(type='button' :class="claseBtnEstado('Candidato')" @click="setEstado('Candidato')") Candidatos
							button(type='button' :class="claseBtnEstado('Aprobado')" @click="setEstado('Aprobado')") Aprobados
							button(type='button' :class="claseBtnEstado('Eliminado')" @click="setEstado('Eliminado')") Eliminados
					.row
						.col
							.form-group
								label(for='') Límite de resultados
								br
								.btn-group
									button(:class="(filtro.max === 50) ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-default'" @click="setLimite('50')") 50
									button(:class="(filtro.max === 100) ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-default'" @click="setLimite('100')") 100
									button(:class="(filtro.max === 500) ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-default'" @click="setLimite('500')") 500
		.card-footer
			button.btn-sm.m-1.btn.btn-success(type='button' @click='buscar()')
				span.fa.fa-search.mr-2
				| Buscar
			button.btn-sm.m-1.btn.btn-danger(type='button' @click='reset()')
				span.fa.fa-refresh.mr-2
				| Reset
			button.btn-sm.m-1.btn.btn-primary(type='button' @click="goEditarContrato('nuevo')")
				span.fa.fa-edit.mr-2
				| Nuevo contrato
			button.btn-sm.m-1.btn.btn-warning(type='button' @click="verDescargaVacio = true")
				span.fa.fa-download.mr-2
				| Descargar contrato vacío
	.card.mt-2
		.card-header
			| Resultados ({{ listadoContratos.length }} contratos)
		.table-responsive
			table.table.table-condensed.table-striped.m-0
				thead.bg-dark.text-white
					tr
						th ID
						th Empresa
						th Fecha
						th Agente
						th Cliente
						th T&iacute;tulo
						th(v-if="hayEventos") Evento(s)
						th(v-if="hayPartidas") Partida(s)
						th Tipo
						th Facturado a
						th Importe
						th Estado
						th
				tbody
					tr(
						v-for='contrato in listadoFiltrado'
						track-by='$index'
						:class="claseContrato(contrato)"
					)
						td.p-1
							| {{ contrato.ContratoID }}
							//- br
							//- | {{ contrato.ContratoOriginal}}
						td.p-1 {{contrato.EmpresaNombre}}
						td.p-1 {{ contrato.FechaCreacion | moment('DD-MM-YYYY') }}
						td.p-1 {{ contrato.AgenteNombre}}
						td.p-1
							| {{ contrato.ClienteNombre }}
							div(v-if='contrato.IntermediarioNombre')
								span(style='color:#888888;') {{contrato.IntermediarioNombre}}
						td.p-1 {{ contrato.Titulo }}
						td.p-1(v-if="hayEventos") {{ contrato.EventoNombre }}
						td.p-1(v-if="hayPartidas") {{ contrato.PartidaNombre }}
						td.p-1 {{ contrato.TipoNombre }}
						td.p-1 {{ contrato.EmpresaNombre }}
						td.p-1 {{ contrato.Importe | currency}}
						td.p-1(:style="claseCeldaEstado(contrato)")
							| {{ contrato.Estado}}
						td.p-1.text-center
							button.btn.btn-sm.btn-primary(type='button' @click='ver(contrato.ContratoID)')
								span.fa.fa-eye
					tr.bg-danger(style='color: white;font-weight:bold;' v-if='listadoContratos.length > 0')
						td.p-1
						td.p-1
						td.p-1
						td.p-1
						td.p-1
						td.p-1
						td.p-1(v-if="hayEventos")
						td.p-1(v-if="hayPartidas")
						td.p-1
						td.p-1(style='text-align:right;') Total:
						td.p-1(style='text-align:left;') {{ compTotalImporteAprobados | currency(&apos;&euro;&apos;) }}
						td.p-1
						td.p-1
	modal(:max-width="1600", v-if='$route.params.id', :top="10")
		.card.text-left
			.card-header
				button.close(@click="$router.push('/main/contratos/listado')") &times;
			.card-body
				detalle-contrato(:ContratoID="$route.params.id")
	editor-contrato(:id-contrato='editarContrato' v-if='editarContrato' @cerrar='cerrarEditor()')
	modal-descarga(v-if="verDescargaVacio" @cerrar="verDescargaVacio = false")
</template>

<script>
import DetalleContrato from '../visor-contrato/visor-contrato'
import EditorContrato from './editor'
import ModalDescarga from './modal-descargar.vue'
import API from '../../services/api'
import { mapGetters } from 'vuex'

export default {
	components: {
		'detalle-contrato': DetalleContrato,
		'editor-contrato': EditorContrato,
		'modal-descarga': ModalDescarga
	},
	data: function () {
		return {
			filtro: {
				agente: '',
				fechaIni: null,
				fechaFin: null,
				cliente: '',
				partida: '',
				titulo: '',
				evento: '',
				estado: null,
				max: 50,
				destino: null,
				intermediario: ''
			},
			mostrarEliminados: false,
			verDescargaVacio: false,
			listadoDestinos: [],
			listadoContratos: [],
			verDetalles: null,
			editarContrato: null
		}
	},

	created: function () {
		this.buscar()
		API.getDestinos()
			.then(res => {
				this.listadoDestinos = res.data.destinos
			})
			.catch(e => {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: `Error cargando los destinos`
				})
			})
	},

	filters: {
		estado (estado) {
			switch (parseInt(estado)) {
			case 0:
				return 'Previsión'
			case 1:
				return 'Sin aprobar'
			case 2:
				return 'Aprobado'
			default:
				return ''
			}
		}
	},

	computed: {
		...mapGetters({
			permisos: 'permisos/permisos'
		}),
		hayEventos () {
			return this.listadoFiltrado.reduce((ant, actual) => {
				if (ant === true) {
					return true
				}

				return (actual.EventoID)
			}, false)
		},
		hayPartidas () {
			return this.listadoFiltrado.reduce((ant, actual) => {
				if (ant === true) {
					return true
				}

				return (actual.PartidaID)
			}, false)
		},
		compTotalImporteAprobados () {
			let total = 0

			for (let i = 0; i < this.listadoFiltrado.length; i++) {
				const importe = parseFloat(this.listadoFiltrado[i].ImporteTotal)

				if (!isNaN(importe)) {
					total = total + importe
				}
			}

			return total
		},
		listadoFiltrado () {
			return this.listadoContratos
		}
	},

	methods: {
		claseCeldaEstado (contrato) {
			let color, bg
			switch (contrato.Estado) {
			case 'Aprobado':
				color = '#112211'
				bg = '#29D967'
				break
			case 'Borrador':
				color = '#222222'
				bg = '#e0e0e0'
				break
			case 'Candidato':
				color = '#222222'
				bg = '#F2B950'
				break
			case 'Eliminado':
				color = 'white'
				bg = '#F28066'
				break
			case 'Rechazado':
				color = '#222222'
				bg = '#F2E5BD'
				break
			default:
				color = '#222222'
				bg = '#F2E5BD'
			}

			return {
				color: color,
				backgroundColor: bg,
				textAlign: 'center'
			}
		},
		claseContrato (contrato) {
			if (contrato.Estado === 'Borrador') {
				return 'bg-warning'
			} else if (contrato.Estado === 'Candidato') {
				return 'bg-success text-white'
			} else if (contrato.Estado === 'Eliminado') {
				return 'bg-danger text-white'
			}

			if (contrato.ImporteTotal < 0) {
				return 'text-danger'
			}

			return ''
		},
		claseBtnEstado (estado) {
			if (estado === this.filtro.estado) {
				if (estado === null) {
					return 'btn btn-sm btn-success'
				}
				return 'btn btn-sm btn-primary'
			} else {
				return 'btn btn-sm btn-default'
			}
		},
		setEstado (estado) {
			this.filtro.estado = estado
			this.buscar()
		},
		setLimite (limite) {
			this.filtro.max = limite
			this.buscar()
		},
		buscar () {
			const filtro = JSON.parse(JSON.stringify(this.filtro))
			filtro.fechaIni = this.getFechaString(this.filtro.fechaIni)
			filtro.fechaFin = this.getFechaString(this.filtro.fechaFin)

			API.buscar(filtro)
				.then(listado => {
					this.listadoContratos = listado.data.resultados
				})
				.catch(e => {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: `Error buscando los contratos`
					})
				})
		},

		getFechaString (fecha) {
			if (fecha === null) {
				return null
			}

			return Math.floor(fecha.getTime() / 1000)
		},
		reset () {
			this.filtro = {
				agente: '',
				fechaIni: null,
				fechaFin: null,
				cliente: '',
				partida: '',
				evento: '',
				estado: null,
				max: 50
			}
			this.buscar()
		},
		ver (idContrato) {
			// this.$router.push('/main/contratos/ver/' + idContrato)
			this.$router.push('/main/contratos/listado/' + idContrato)
			// this.verDetalles = idContrato
		},
		cerrarVista () {
			this.verDetalles = null
		},
		goEditarContrato (ID) {
			if (this.verDetalles) {
				this.cerrarVista()
			}
			this.$router.push('/main/contratos/editar/' + ID)
			// this.editarContrato = ID
		},
		cerrarEditor () {
			this.editarContrato = null
			this.buscar()
		}
	}
}
</script>


<style scoped>
td {
	vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/listado/index.vue